import styles from './styles.module.css'
import Text from '../../Text'
import React from 'react'
import { PALETTE } from '../../../styles/constants'



function OldLogosShowcase({ backgroundColor = { value: PALETTE.black }, textColor = { value: PALETTE.white }, title, logos }) {
  return (
    <div className={styles.wrapper} style={{ background: backgroundColor.value, color: textColor.value }}>
      <div className={styles.contentWrapper}>
        <Text type={'h4'}>{title}</Text>
        <div className={styles.logosWrapper}>
          {/* task #67: each logo is a ResolvedImage descriptor; the <img> src takes .src.
              The former styled.img.attrs forced alt='' + role='presentation' on every
              logo, so those are hard-coded here to preserve identical output. */}
          {logos.map((logo, i) => (
            <img
              className={styles.logo}
              src={logo?.src}
              alt=""
              role="presentation"
              style={{ aspectRatio: logo?.aspectRatio || '1 / 1' }}
              key={logo?._key || i}
            />
          ))}
        </div>
      </div>
    </div>
  )
}

export default OldLogosShowcase
